import * as types from "./types";

export const migratingMembers = () => ({
  type: types.MIGRATING_MEMBERS,
  loading: true,
});

export const migratingMembersError = (error) => ({
  type: types.MIGRATING_MEMBERS_ERROR,
  error: error,
  loading: false
});

export const migrateMembersSuccess = () => ({
  type: types.MIGRATING_MEMBERS,
  loading: false
});

export const removingMember = () => ({
  type: types.REMOVING_MEMBER,
  loading: true,
});

export const removingMemberError = (error) => ({
  type: types.REMOVING_MEMBER_ERROR,
  error: error,
  loading: false
});

export const removingMemberSuccess = () => ({
  type: types.REMOVING_MEMBER_SUCCESS,
  loading: false
});




export const sendingPuzzleOrder = () => ({
  type: types.REQUESTING_PUZZLE,
  loading: true,
});

export const markingInterest = () => ({
  type: types.MARKING_INTEREST,
  loading: true,
});

export const markedInterest = () => ({
  type: types.MARKED_INTEREST,
  loading: false,
});

export const errorMarkingInterest = (error) => ({
  type: types.ERROR_MARKING_INTEREST,
  error: error,
  loading: false
});

export const invitingFriends = () => ({
  type: types.INVITING_FRIENDS,
  loading: true,
});

export const invitedFriends = () => ({
  type: types.INVITED_FRIENDS,
  loading: false,
});

export const errorInvitingFriends = (error) => ({
  type: types.ERROR_INVITING_FRIENDS,
  error: error,
  loading: false
});

export const sendPuzzleOrder = () => ({
  type: types.SEND_PUZZLE_REQUEST,
  loading: false,
});

export const errorSendingPuzzleOrder = (error) => ({
  type: types.ERROR_REQUESTING_PUZZLE,
  error:error,
  loading: false,
});

export const requestingCircle = () => ({
  type: types.REQUESTING_CIRCLE,
  loading: true,
});

export const requestedCircle = () => ({
  type: types.REQUESTED_CIRCLE,
  loading: false,
});

export const errorRequestingCircle = (error) => ({
  type: types.ERROR_REQUESTING_CIRCLE,
  error: error,
  loading: false
});

export const markingProductAsBought = () => ({
  type: types.MARKING_PRODUCT_AS_BOUGHT,
  loading: true,
});

export const markedProductAsBought = () => ({
  type: types.MARKED_PRODUCT_AS_BOUGHT,
  loading: false,
});
 
export const errorMarkingCircles = (error) => ({
  type: types.ERROR_MARKING_CIRCLES,
  error: error,
  loading: false
});

export const fetchingMyCircles = () => ({
  type: types.FETCHING_MY_CIRCLES,
  loading: true,
});

export const fetchedMyCircles = (circles) => ({
  type: types.FETCHED_MY_CIRCLES,
  circles: circles,
  loading: false,
});

export const errorFetchingMyCircles = (error) => ({
  type: types.ERROR_FETCHING_MY_CIRCLES,
  error: error,
  loading: false
});

export const savingCircle=()=>({
  type: types.SAVING_CIRCLE_DETAILS,
  loading: true
});

export const savedCircle=(circle)=>({
  type: types.SAVED_CIRCLE_DETAILS,
  circle: circle,
  loading: false
})

export const errorSavingCircle=(error)=>({
  type: types.ERROR_SAVING_CIRCLE,
  error: error,
  loading: false
})
